export default "__VITE_ASSET__J6mf2TcJ__"